<script>
import compoment from '@/components/draggable/CustomComponents/Radio/DSimpleRadioPreview'
export default {
  name: 'DBrowseSettingPreview',
  extends: compoment
}
</script>
